module.exports = __webpack_public_path__ + "img/bill-background.8dd3f2f6.svg";